import styled from 'styled-components';

import { COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
`;

export const TitleText = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  color: ${COLORS.heading};
`;

export const CountPill = styled(Text)`
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 10px;
  white-space: nowrap;
  background: ${COLORS.surfaceMuted};
  color: ${COLORS.text};
`;